import { Link } from 'react-router-dom'
import styled from 'styled-components'
import spacing from 'utils/spacing'

export const NotFoundTitle = styled.div`
  width: 100%;
  padding: ${spacing.gigantic}px;
  margin-bottom: ${spacing.default}px;
  text-align: center;
  font-size: 3em;
`

export const NotFoundWrapper = styled.div`
  padding-top: 15vh;
  margin: 0 auto;
  width: 60%;

  @media screen and (max-width: 600px) {
    padding-top: 5vh;
  }
`

export const ActionLink = styled(Link)`
  text-decoration: underline;
`

export const NotFoundParagraph = styled.p`
  text-align: center;
`
